import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/teemates/banner.webp";

function Banner() {
  return (
    <section
      className="banner_amj banner_teemates"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="banner_logo">
              <StaticImage
                src="../../../images/case-studies/teemates/logo.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={270}
                height={153}
              />
            </div>
            <h1>Teemates Media App</h1>
            <h6>
              Golf-Centric Social Media App Development When the whole world is
              going social, why not golfers too?
            </h6>
            <p>
              Based on the same idea, client and Tekrevol partnered on building
              a social media platform for global golfers where they could
              exchange their golfing experiences and equipment!
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1 my-auto"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/teemates/banner-img.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={514}
                height={685}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
